// src/components/DataGrid.js
import React, { useRef, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import StethoscopeLoading from '../StethoscopeLoading/StethoscopeLoading';

const CTGrid = (props) => {
  const handleRowClick = (params) => {

    if (props.onRowClickforLabResults) {
      props.onRowClickforLabResults(params.data);
    }
  }
  // const defaultGridOptions = {
  //   rowSelection: 'single',
  //   suppressCellFocus: true,
  //   suppressRowClickSelection: false,
  //   enableCellTextSelection: true
  // };
  const defaultColDef = {
    filter: true,
    // Avoid AG Grid inferred date typings — sorting/filtering then uses parsers that disagree across browsers on MM/DD/YYYY strings.
    cellDataType: false,
  };

  // Native browser tooltips (title) bypass `.ag-tooltip` styling in ag-grid-custom-styles.css.
  // Only pass enableBrowserTooltips={true} when you explicitly want the browser default.
  const useBrowserTooltip = props.enableBrowserTooltips === true;

  // Check if rowData is empty or undefined
  const hasNoData = !props.rowData || props.rowData.length === 0;
  const isLoading = props.loading === true;
  const showSpinner = isLoading && hasNoData;

  const pageSize = 10;
  const shouldPaginate = props.disablePagination ? false : (props.rowData && props.rowData.length > pageSize);

  const gridApiRef = useRef(null);
  const gridHostRef = useRef(null);
  const gridRef = useRef();

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
    params.api.sizeColumnsToFit();
  };

  useEffect(() => {
    const host = gridHostRef.current;
    if (!host || typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(() => {
      gridApiRef.current?.sizeColumnsToFit();
    });
    observer.observe(host);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      const totalRows = gridRef.current.api.getDisplayedRowCount();
      const currentPageSize = gridRef.current.api.paginationGetPageSize();
      const panel = document.querySelector('.ag-theme-balham .ag-paging-panel');
      if (panel) {
        panel.style.display = totalRows <= currentPageSize ? 'none' : '';
      }
    }
  }, [props.rowData]);

  return (
    <div className="card-body">
      <div
        style={{ height: props.height, width: '100%', overflowX: 'hidden', overflowY: 'auto', position: 'relative' }}
        ref={gridHostRef}
        className={`ag-theme-balham pmr-ct-grid p-0 mt-0${props.suppressHorizontalScroll ? ' pmr-ct-grid--fit' : ''}`}
      >
        {!hasNoData && (
          shouldPaginate ? (
            <AgGridReact
              defaultColDef={defaultColDef}
              rowData={props.rowData}
              columnDefs={props.columnDefs}
              domLayout="normal"
              tooltipShowDelay={0}
              pagination={true}
              paginationPageSize={pageSize}
              onRowClicked={handleRowClick}
              enableBrowserTooltips={useBrowserTooltip}
              rowClass={(params) => (params.rowIndex % 2 === 0 ? 'even-row' : 'odd-row')}
              getRowStyle={(params) => ({
                backgroundColor: params.rowIndex % 2 === 0 ? '#f8f9fa' : '#ffffff',
                border: 'none',
                borderBottom: '1px solid #dee2e6'
              })}
              suppressHorizontalScroll={Boolean(props.suppressHorizontalScroll)}
              animateRows={false}
              onGridReady={onGridReady}
            />
          ) : (
            <AgGridReact
              defaultColDef={defaultColDef}
              rowData={props.rowData}
              columnDefs={props.columnDefs}
              domLayout="normal"
              pagination={false}
              enableBrowserTooltips={useBrowserTooltip}
              tooltipShowDelay={0}
              onRowClicked={handleRowClick}
              rowClass={(params) => (params.rowIndex % 2 === 0 ? 'even-row' : 'odd-row')}
              getRowStyle={(params) => ({
                backgroundColor: params.rowIndex % 2 === 0 ? '#ffffff' : 'var(--pmr-bg-grid)',
                border: 'none',
                borderBottom: '1px solid #dee2e6'
              })}
              suppressHorizontalScroll={Boolean(props.suppressHorizontalScroll)}
              animateRows={false}
              onGridReady={onGridReady}
            />
          )
        )}

        {showSpinner ? (
          <StethoscopeLoading overlay message="Loading..." />
        ) : hasNoData ? (
          <div className="pmr-grid-overlay">
            <svg className="pmr-grid-empty__icon" width="56" height="56" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M4 7a2 2 0 0 1 2-2h4l2 2h6a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
              <path d="M9 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
            <span className="pmr-grid-empty__title">No Data Found</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CTGrid;


